import { getWidth } from "../common";

const columns = 11;
export default Array.from({ length: columns }, (_, current) => {
  const field = `switch_detection_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true,
  };
});
